import { Component, OnInit } from '@angular/core';
import { Link } from '../../interfaces/link';
import { MetaDataService } from '../../services/metadata.service';

@Component({
  selector: 'app-page-styleguide',
  templateUrl: './page-styleguide.component.html',
  styleUrls: ['./page-styleguide.component.scss']
})
export class PageStyleguideComponent implements OnInit {
  demoLinksGrid: Link[] = [
    {title: 'Auburn', description: 'Nulla eget orci at dolor vestibulum facilisis. ' +
        'Duis eget eleifend enim, ut malesuada odio?', url: 'http://google.com'},
    {title: 'Auburn', description: 'Nulla eget orci at dolor vestibulum facilisis. ' +
        'Duis eget eleifend enim, ut malesuada odio?', url: 'http://google.com'},
    {title: 'Auburn', description: 'Nulla eget orci at dolor vestibulum facilisis. ' +
        'Duis eget eleifend enim, ut malesuada odio?', url: 'http://google.com'},
  ];
  demoSelectric = [
    {value: 1, name: 'Option 1'},
    {value: 2, name: 'Option 2'},
    {value: 3, name: 'Option 3'}
  ];

  constructor(
    private mds: MetaDataService
  ) { }

  ngOnInit() {
    // set metadata
    this.mds.setMetaData({meta_title: 'Styleguide | Auburn'});
  }

}
